<template>
  <b-tabs class="my-4" nav-wrapper-class="card-tabs" @input="tabChange">
    <b-card no-body class="tabs-card">
      <b-tab v-for="tab in tabs" :key="tab.title" :title="tab.title" no-body>
        <component v-if="tab.loaded"
          :is="tab.component"
          :cid="cid">
        </component>
      </b-tab>
    </b-card>
  </b-tabs>
</template>

<script>
import LiveAds from '@/reports/pages/AdReview/LiveAds'
import AdStatus from '@/reports/pages/AdReview/AdStatus'

export default {
  props: {
    cid: { type: String, required: false }
  },
  data () {
    return {
      tabs: [
        { title: 'Live Ads', component: LiveAds, loaded: false }
        // { title: 'Ad Status', component: AdStatus, loaded: false }, finish later
      ]
    }
  },
  methods: {
    tabChange (index) {
      this.tabs[index].loaded = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/reports/pages/AdReview.vue